import React from 'react';
import { Switch, Route } from 'react-router-dom';

import http from 'api/http';
import { boatAPI } from 'api/requests';

import WithUser from 'HOC/User';

import List from './List';
import { ACTION, STATUS } from 'constants/index';
import { ROLES } from 'constants/roles';
import NotificationManager from 'dom-managers/notification';
import Button, { buttonColor, buttonType } from 'Components/Button';
import Modal from 'Components/Modal';
import Application from './Application';

@WithUser
export default class BoatManufacturer extends React.Component {
  state = {
    currentModelYear: '',
    requestInProcess: false,
    isModalOpen: false,
  };

  roleSwitch = () => {
    const { user } = this.props;
    if (user.getActiveRole() !== ROLES.BOAT_MANUFACTURER.serverName) {
      user.changeMenu(ROLES.BOAT_MANUFACTURER.serverName);
    }
  };

  componentDidMount() {
    this.roleSwitch();

    http.get(boatAPI.currentModelYear).then(({ data }) => {
      this.setState({ currentModelYear: data[1] || data[0] });
    });
  }

  createActionsList = boat => {
    const { currentModelYear } = this.state;
    const { user } = this.props;
    const boatInPastYears = (+boat.year || +boat.boatSpecifications.year) < +currentModelYear;
    const userIsInternal = user.isInternal();
    const additionalActionsAllowed = userIsInternal || !boatInPastYears;
    const actions = [ACTION.DETAILS];

    if (!user.isInspector()) {
      if (boat.status === STATUS.DRAFT) {
        actions.push(ACTION.DELETE);
      }

      // if (boatInPastYears) {
      actions.push(ACTION.ROLL_OVER);
      // }

      if (boat.status !== STATUS.DRAFT && boat.status !== STATUS.DEACTIVATED && additionalActionsAllowed) {
        actions.push(ACTION.DEACTIVATE);
      }

      if (boat.status === STATUS.DEACTIVATED && additionalActionsAllowed) {
        actions.push(ACTION.REACTIVATE);
      }

      if (boat.status === STATUS.DRAFT || (boat.status !== STATUS.DEACTIVATED && additionalActionsAllowed)) {
        actions.push(ACTION.EDIT);
      }
    }

    return actions;
  };

  selectAction = (actionKey, boat) => {
    const { user } = this.props;

    switch (actionKey) {
      case ACTION.ROLL_OVER:
        return new Promise((resolve, reject) => {
          this.$modalBody = 'Are you sure you want to roll the boat over?';
          this.$confirmModalAction = this._confirmRollOver(boat, resolve);
          this.setState({ isModalOpen: true });
        });
      case ACTION.DEACTIVATE:
        return new Promise((resolve, reject) => {
          this.$modalBody = 'Are you sure you want to Deactivate this application?';
          this.$confirmModalAction = this._confirmDeactivate(boat, resolve);
          this.setState({ isModalOpen: true });
        });
      case ACTION.REACTIVATE:
        return new Promise((resolve, reject) => {
          this.$modalBody = 'Are you sure you want to Reactivate this application?';
          this.$confirmModalAction = this._confirmReactivate(boat, resolve);
          this.setState({ isModalOpen: true });
        });
      case ACTION.DELETE:
        return new Promise((resolve, reject) => {
          this.$modalBody = 'Are you sure you want to Delete this application?';
          this.$confirmModalAction = this._confirmDelete(boat, resolve);
          this.setState({ isModalOpen: true });
        });
      case ACTION.DETAILS:
        return new Promise((resolve, reject) => {
          return user.goToApplicationDetails(boat.id);
        });
      case ACTION.EDIT:
        return new Promise((resolve, reject) => {
          return user.goToApplicationStep(boat.id, 'boat_specifications');
        });
      default:
        return null;
    }
  };

  _confirmDeactivate = (boat, cb) => () => {
    const { requestInProcess } = this.state;

    if (requestInProcess) return null;

    this.setState({ requestInProcess: true }, () => {
      http
        .put(boatAPI.deactivate(boat.id))
        .then(({ data }) => {
          cb(data || STATUS.DEACTIVATED);
          NotificationManager.success(1, 'The status was updated successfully.');
        })
        .finally(() => {
          this._closeModal();
        });
    });
  };

  _confirmReactivate = (boat, cb) => () => {
    const { requestInProcess } = this.state;

    if (requestInProcess) return null;

    this.setState({ requestInProcess: true }, () => {
      http
        .put(boatAPI.reactivate(boat.id))
        .then(({ data }) => {
          cb(data || STATUS.INCOMPLETE);
          NotificationManager.success(1, 'The status was updated successfully.');
        })
        .finally(() => {
          this._closeModal();
        });
    });
  };

  _confirmRollOver = (boat, cb) => () => {
    const { requestInProcess } = this.state;

    if (requestInProcess) return null;

    this.setState({ requestInProcess: true }, () => {
      http
        .post(boatAPI.rollOver(boat.id))
        .then(({ data }) => {
          cb(data);
          NotificationManager.success(1, 'Your boat has been successfully rolled over.');
        })
        .finally(() => {
          this._closeModal();
        });
    });
  };

  _confirmDelete = (boat, cb) => () => {
    const { requestInProcess } = this.state;

    if (requestInProcess) return null;

    this.setState({ requestInProcess: true }, () => {
      http
        .delete(boatAPI.details(boat.id))
        .then(({ data }) => {
          cb(data);
          NotificationManager.success(1, 'The boat was deleted successfully.');
          this._closeModal();
        })
        .catch(() => {
          this._closeModal();
        });
    });
  };

  _closeModal = () => {
    this.setState({ isModalOpen: false, requestInProcess: false });
  };

  render() {
    const { isModalOpen, requestInProcess, currentModelYear } = this.state;
    const { match, user } = this.props;

    return (
      <React.Fragment>
        <Switch>
          <Route
            path={`${match.path}/application/:applicationId`}
            render={({ match }) => (
              <Application
                user={user}
                match={match}
                createActionsList={this.createActionsList}
                selectAction={this.selectAction}
              />
            )}
          />
          <Route
            exact
            path={`${match.path}`}
            render={({ match }) => (
              <List
                user={user}
                currentModelYear={currentModelYear}
                createActionsList={this.createActionsList}
                selectAction={this.selectAction}
              />
            )}
          />
        </Switch>

        <Modal isOpen={isModalOpen}>
          <div className='ect-modal-header'>Confirmation</div>
          <div className='ect-modal-body'>{this.$modalBody}</div>
          <div className='ect-modal-footer'>
            <Button
              label='No'
              buttonClassName='_width_135 _height_40'
              onClick={this._closeModal}
              color={buttonColor.gray}
              type={buttonType.secondary}
            />
            <Button
              label='Yes'
              disabledWithSpinner={requestInProcess}
              buttonClassName='_width_135 _height_40'
              onClick={this.$confirmModalAction}
            />
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/index.jsx